import React from 'react';
import Modal from 'react-modal';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search, CSVExport } from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, PaginationTotalStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';

const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
        Mostrando {from} a {to} de {size} Resultados
    </span>
);

const { ExportCSVButton } = CSVExport;

class modalBusquedaFiltro extends React.Component {
    state = {
        selected: []
    }

    handleOnSelect = (row, isSelect) => {

        this.setState(() => ({
            selected: isSelect ? [row[this.props.id]] : []
        }));

        this.props.selectRow.onSelect(row, isSelect);
    }

    calculasizePerPageList = (cantidad) => {

        if (cantidad <= 15) {
            return [{ text: '5', value: 5 }, { text: '10', value: 10 }, { text: 'Todo', value: cantidad }];
        }

        if (cantidad <= 20) {
            return [{ text: '5', value: 5 }, { text: '10', value: 10 }, { text: '15', value: 15 }, { text: 'Todo', value: cantidad }];
        }

        if (cantidad <= 50) {
            return [{ text: '5', value: 5 }, { text: '10', value: 10 }, { text: '15', value: 15 }, { text: '25', value: 25 }, { text: '35', value: 35 }, { text: 'Todo', value: cantidad }];
        }
        if (cantidad > 50) {
            return [{ text: '5', value: 5 }, { text: '10', value: 10 }, { text: '15', value: 15 }, { text: '25', value: 25 }, { text: '35', value: 35 }, { text: '65', value: 65 }, { text: '85', value: 85 }, { text: '100', value: 100 }, { text: 'Todo', value: cantidad }];
        }

        return [];
    }

    render() {
        const { selectedModal, contentLabel, label, id, datos, columnas, striped, hover, condensed, onDoubleClick, clases } = this.props;

        let selectRow = { ...this.props.selectRow };
        selectRow.selected = this.state.selected;
        selectRow.onSelect = this.handleOnSelect;

        const { SearchBar } = Search;
        const clase = "btn btn-sm pull-right flipInX animated";
        const iclase = "fa fa-file-excel-o";
        const _size = datos ? datos.length : 0;
        const _sizePerPageList = this.calculasizePerPageList(_size);
        const _hideSizePerPage = _size === 0;

        let optPaginacion = {
            custom: true,
            paginationSize: 4,
            pageStartIndex: 1,
            alwaysShowAllBtns: true, // Always show next and previous button
            withFirstAndLast: true, // Hide the going to First and Last page button
            hideSizePerPage: _hideSizePerPage,//false, // Hide the sizePerPage dropdown always
            hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
            firstPageText: 'Primero',
            prePageText: 'Anterior',
            nextPageText: 'Siguiente',
            lastPageText: 'Último',
            nextPageTitle: 'Primera Página',
            prePageTitle: 'Pre page',
            firstPageTitle: 'Siguinete Página',
            lastPageTitle: 'Última Página',
            showTotal: true,
            paginationTotalRenderer: customTotal,
            sizePerPageList: _sizePerPageList,
            variation: 'dropup',
            dataSize: _size
        };

        const customStyles = {
            content: {
                position: 'fixed',
                position: 'absolute',
                top: '25%',
                left: '25%',
                right: '25%',
                bottom: '25%',
                with: '50%',
                height: '67%',
                padding: '5px'
            },
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.75)',
            }
        };

        const rowEvents = {
            onDoubleClick: onDoubleClick
        };

        const NoDatos = 'No hay datos que mostrar';

        return (
            <Modal
                isOpen={selectedModal}
                contentLabel={contentLabel}
                style={customStyles}
                ariaHideApp={false}
            >
                <div>
                    <div className="modal-header">
                        <h2 className="modal-title" id="exampleModalLabel">{label}</h2>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.props.cerrarModal}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <ToolkitProvider
                                keyField={id}
                                data={datos}
                                columns={columnas}
                                search
                            >
                                {
                                    props => (
                                        <div className='col'>
                                            <div className='row'>
                                                <div class="col-xs-6">
                                                    <div style={{ float: "left" }}>
                                                        <ExportCSVButton {...props.csvProps} className={clase}  >
                                                            <i className={iclase} ></i>
                                                        </ExportCSVButton>
                                                    </div>
                                                </div>
                                                <div class="col-xs-6">
                                                    <SearchBar {...props.searchProps} placeholder="Buscar" />
                                                </div>
                                            </div>
                                            <hr />
                                            <PaginationProvider pagination={paginationFactory(optPaginacion)}>
                                                {
                                                    ({ paginationProps, paginationTableProps }) => (
                                                        <div className='col'>
                                                            <div className='table-responsive'>
                                                                <BootstrapTable
                                                                    {...props.baseProps}
                                                                    {...paginationTableProps}
                                                                    striped={striped}
                                                                    hover={hover}
                                                                    condensed={condensed}
                                                                    selectRow={selectRow}
                                                                    rowEvents={rowEvents}
                                                                    className={clases}
                                                                    noDataIndication={NoDatos}
                                                                />
                                                            </div>
                                                            <SizePerPageDropdownStandalone {...paginationProps} />
                                                            <PaginationTotalStandalone {...paginationProps} />
                                                            <PaginationListStandalone {...paginationProps} />
                                                        </div>
                                                    )
                                                }
                                            </PaginationProvider>
                                        </div>
                                    )
                                }
                            </ToolkitProvider>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <div className="tooltip2">
                            <span className="tooltiptext2">Cerrar</span>
                            <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={this.props.cerrarModal}>Cerrar</button>
                        </div>
                        <div className="tooltip2">
                            <span className="tooltiptext2">Seleccionar</span>
                            <button type="button" className="btn btn-primary" onClick={this.props.seleccionModal}>Seleccionar</button>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default modalBusquedaFiltro;